import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "../../../store/loaderSlice";

interface LoadingIndicatorProps {
  message: string;
}

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ message }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(showLoader(message));
    return () => { dispatch(hideLoader()); };
  }, [dispatch, message]);

  return null;
};
